import { createFileRoute } from '@tanstack/react-router'
import AccessDashboard from '../../../../../views/Admin/AccessDashboard/AccessDashboard'
import React from 'react'
import { generateRandomString } from '../../../../utils'
import { getAllData } from '../../../../../utils/data'
import useRouteLog from '../../../../hooks/useRouteLog'
import { adminAuth } from '../../../../hooks/beforeLoad/adminAuth'
import useListener from '../../../../hooks/useListener'
import LoadingScreen from '../../../../LoadingScreen/LoadingScreen'

export const Route = createFileRoute('/admin/_layout/access/$id')({
  beforeLoad: adminAuth,
  pendingComponent: () => <LoadingScreen />,
  loader: async ({ context, params }) => {
    const rsg = generateRandomString()
    const label = `/admin/_layout/access/$id.tsx loader: ${rsg}`
    console.time(label)

    const { client, queryClient } = context
    const { id } = params

    /* Assettrak Access */
    const assettrakAccess = await queryClient.ensureQueryData({
      queryKey: ['assettrak-access', 'get', id],
      queryFn: () => client.service('assettrak-access').get(id),
      enabled: !!id,
      gcTime: 0,
      staleTime: 0
    })

    const allowedAgencies = Array.from(
      new Set(assettrakAccess.allowed_agencies.split(',').map((agencyId: string) => parseInt(agencyId)))
    )

    /* Agencies */
    const agenciesQuery = {
      id: {
        $in: allowedAgencies
      }
    }
    const agencies = await queryClient.ensureQueryData({
      queryKey: ['agencies', 'find', agenciesQuery],
      queryFn: () => getAllData(client, 'agencies', agenciesQuery)
    })

    const assettrakTimeFilter = window.localStorage.getItem('assettrak_time_filter') || '1_day' // default to 1 day

    const vehicleVehicleLocationsQuery = {
      allowed_agencies: allowedAgencies,
      timeframe: assettrakTimeFilter
    }

    const vehicleVehicleLocations = await queryClient.ensureQueryData({
      queryKey: ['vehicle-vehicle-location', 'find', vehicleVehicleLocationsQuery],
      queryFn: () =>
        client.service('vehicle-vehicle-location').find({
          query: vehicleVehicleLocationsQuery
        })
    })

    /* Vehicle Types */
    const vehicleTypeQuery = {}
    const vehicleTypes = await queryClient.ensureQueryData({
      queryKey: ['vehicle-type', 'find', vehicleTypeQuery],
      queryFn: () => getAllData(client, 'vehicle-type', vehicleTypeQuery) // client.service('vehicle-type').find({ query: vehicleTypeQuery })
    })

    /* Device Types */
    const deviceTypesQuery = {}
    const deviceTypes = await queryClient.ensureQueryData({
      queryKey: ['device-type', 'find', deviceTypesQuery],
      queryFn: () => getAllData(client, 'device-type', deviceTypesQuery)
    })

    /* Vehicle Categories */
    const vehicleCategoryQuery = {}
    const vehicleCategories = await queryClient.ensureQueryData({
      queryKey: ['vehicle-category', 'find', vehicleCategoryQuery],
      queryFn: () => getAllData(client, 'vehicle-category', vehicleCategoryQuery) // client.service('vehicle-category').find({ query: vehicleCategoryQuery })
    })

    /* ADSB */
    const adsbQuery = {
      adsb_position_updates: 1
    }
    const adsb = await queryClient.ensureQueryData({
      queryKey: ['unit-location', 'find', adsbQuery],
      queryFn: () => getAllData(client, 'unit-location', adsbQuery) // client.service('unit-location').find({ query: adsbQuery })
    })

    console.timeEnd(label)

    return {
      assettrakAccess,
      vehicles: vehicleVehicleLocations.vehicles,
      vehicleLocations: vehicleVehicleLocations.vehicle_locations,
      deviceTypes,
      agencies,
      vehicleTypes,
      vehicleCategories,
      adsb
    }
  },
  component: RouteComponent
})

function RouteComponent() {
  useRouteLog('/admin/_layout/access/$id')
  useListener('assettrak-access')
  return <AccessDashboard />
}
